import { useQuery } from '@tanstack/react-query';
import { getPaymentSummary } from '@/api/getPaymentSummary';
import { queryKeys } from '@/constants/queryKeys';

interface Params {
  orderNumber: string;
}

export const useGetPaymentSummary = ({ orderNumber }: Params) => {
  const browserUserId = localStorage.getItem('browserUserId');
  return useQuery({
    queryKey: queryKeys.paymentSummary({ orderNumber }),
    queryFn: ({ signal }) => getPaymentSummary({ orderNumber, browserUserId, signal }),
    staleTime: Infinity,
  });
};
